import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GeographicScopesWithRate } from '../../../models/surveys-tasks/SurveyTaskDetails';

export interface DialogData {
  record: GeographicScopesWithRate[],
}
@Component({
  selector: 'app-surveys-tasks-geographic-scope',
  standalone: false,
  templateUrl: './surveys-tasks-geographic-scope.component.html'
})
export class SurveysTasksGeographicScopeComponent {

  constructor(
    private dialogRef: MatDialogRef<SurveysTasksGeographicScopeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,) {

  }

}
